export const FETCH_CITIES = 'app/core/reducers/cities/FETCH_CITIES';
